import React, {useState, useEffect, useRef} from 'react';
import Chart from "chart.js";
import logo from '../logo.svg';
import 'chartjs-plugin-labels';
import pattern from 'patternomaly';
import {Card} from 'react-bootstrap';
import watermark from 'watermarkjs';


const PieGraph = (props) => {
    const chartRef = useRef();
    const chartPoint = new Image();
    chartPoint.src = logo;
    

    if(window.chart && window.chart !== null){
        window.chart.destroy();
    }
    
    useEffect(() => {
        const imageArr = [];
        for (var i = 0; i < props.values.length; i++){
            imageArr.push( {
                src: props.images[i],
                width: props.width[i],
                height: props.height[i]
              });
        }

        const zefSide = () => {
            if (props.chartType == "bar"){
                return `callbacks: {
                    label: function() {},
                 }`
            } else {
                return ""
            }
        }

        const colorPattern = [];
        for (var z = 0; z < props.patterns.length; z++){
            console.log(props.patterns);
            if (props.patterns.length > 0){
                if (props.patterns[z] === "none"){
                    console.log("yes yes yes")
                    colorPattern.push(props.colors[z])
                } else{
                    console.log("no no no")
                    colorPattern.push(pattern.draw(props.patterns[z], props.colors[z]))
                    
                }
            }
        }


        const watermarkedDataURL = (canvas,text) =>{
            var tempCanvas=document.createElement('canvas');
            var tempCtx=tempCanvas.getContext('2d');
            var cw,ch;
            cw=tempCanvas.width=canvas.width;
            ch=tempCanvas.height=canvas.height;
            tempCtx.drawImage(canvas,0,0);
            tempCtx.font="24px verdana";
            var textWidth=tempCtx.measureText(text).width;
            tempCtx.globalAlpha=.50;
            tempCtx.fillStyle='white'
            tempCtx.fillText(text,cw-textWidth-10,ch-20);
            tempCtx.fillStyle='black'
            tempCtx.fillText(text,cw-textWidth-10+2,ch-20+2);
            // just testing by adding tempCanvas to document
            document.body.appendChild(tempCanvas);
            return(tempCanvas.toDataURL());
        }
        
        const myChartRef = chartRef.current.getContext("2d");
        
        window.chart = new Chart(myChartRef, {
            type: props.chartType,
            data: {
                //Bring in data
                labels: props.labels,
                datasets: [
                    {
                        label: props.title,
                        data: props.values,
                        // data: [13],
                        // lineTension: props.bezierCurve ? 0.4 : 0,
                        backgroundColor: colorPattern,
                        // pointBorderColor: props.colors,
                        // pointBackgroundColor: props.colors,
                        // backgroundColor: props.lineColor,
                        // fill: props.fill,
                        // borderColor: props.lineColor,
                        // pointStyle: chartPoint,
                    }
                ]
            },
            options: {
                plugins: {
                    labels: {
                      // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
                      render: props.labelType,
                      images: imageArr,
                    }
                },
                //Customize chart options
                // responsive: false,
                legend: {
                    display: props.chartType == "bar" ? false : true,
                },
                title: {
                    display: props.displayTitle,
                    text: props.title
                  },
                animation: {
                    duration: 0.2,
                    onComplete:() => {
                        window.chart.options.animation.onComplete = null; //disable after first render
                        done();
                     }
                  },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: props.zero
                        }
                    }]
                },
            },
            
        });

        function done(){
             // if(props.displayValues){  
            //     window.chart.destroy();
            //     var ctx = this.chart.ctx;
            //     ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
            //     ctx.fillStyle = this.chart.config.options.defaultFontColor;
            //     ctx.textAlign = 'center';
            //     ctx.textBaseline = 'bottom';
            //     this.data.datasets.forEach(function (dataset) {
            //         for (var i = 0; i < dataset.data.length; i++) {
            //             var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
            //             ctx.fillText(dataset.data[i], model.x, model.y - 5);
            //         }
            //     });
            // }

            var ctx = chartRef.current.getContext("2d");
            ctx.font = "12px Helvetica Neue";
            ctx.fillStyle = "rgba(255,100,100,0.5)";
            ctx.strokeStyle = "rgba(255,100,100,0.5)";          
            ctx.textAlign = "center";
            ctx.fillText("ChartyMcChartChart.com", 70, 10);
            
            let url_base64 = window.chart.toBase64Image();
            
            
            // console.log(url_base64);
            props.setBase64Href(url_base64)
          }
      })

        return (
            <Card className="card-container" style={{height:"500px", marginBottom: "16px" }}>
                <Card.Body>
                        <div>
                            <canvas
                                id="myChart"
                                ref={chartRef}
                                style={{backgroundColor: '#fff', maxWidth:"90%", display:"inline"}}
                            />
                        </div>
                </Card.Body>
            </Card>            
        )
}

export default PieGraph;